// src/contexts/StoreAdminBranchContext.js
// 72차 신규: 매장관리(홈·통계)/운영관리(예약·설정) 하단 탭이 각각 별도의
// StoreAdminScreen 인스턴스라서, 지점(브랜치) 선택 상태를 이 컨텍스트로
// 끌어올려 두 탭이 같은 선택값을 공유하도록 한다. (navigation/index.js가 Provider)
import { createContext } from 'react';

export const StoreAdminBranchContext = createContext(null);
